module.exports = __webpack_public_path__ + "img/1487672419.543f484f.jpg";